import { StatusDot } from '@raro/ui';
import { Link } from 'react-router';
import { SOURCE_STATUS_LABELS, SOURCE_TYPE_LABELS, formatDate, sourceIsPending } from '../lib/format';
import type { Source } from '../lib/types';

export function SourceList({ sources }: { sources: Source[] }) {
  return (
    <div className="rr-list">
      {sources.map((s) => (
        <Link key={s.id} to={`/fontes/${s.id}`} className="rr-list-row">
          <StatusDot tone={s.status === 'processed' ? 'active' : s.status === 'failed' ? 'down' : 'hollow'} />
          <div>
            <div className="rr-list-row__title">{s.title}</div>
            <div className="rr-list-row__meta">
              <span>{SOURCE_TYPE_LABELS[s.type]}</span>
              {s.status === 'processed' ? (
                <>
                  <span>{s.chunkCount} trechos</span>
                  {s.wordCount ? <span>{s.wordCount} palavras</span> : null}
                  {s.evidenceCount ? <span>{s.evidenceCount} evidências</span> : null}
                </>
              ) : (
                <span className={s.status === 'failed' ? 'rr-list-row__err' : undefined}>
                  {SOURCE_STATUS_LABELS[s.status]}
                  {sourceIsPending(s.status) ? '…' : ''}
                </span>
              )}
              {s.error && s.status === 'processed' && <span className="rr-faint">· {s.error}</span>}
              {s.error && s.status === 'failed' && <span className="rr-list-row__err">· {s.error.slice(0, 80)}</span>}
            </div>
          </div>
          <div className="rr-list-row__right">{formatDate(s.createdAt)}</div>
        </Link>
      ))}
    </div>
  );
}
